import React, { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import MenuAppBar from "../ownersDashboard/dashboardNavBar";
import MenuBar from "../menuBar";
import { useTranslation } from "react-i18next";
import { useResponsive } from "../../hooks/useResponsive";
import { CustomTab } from "../../components/CustomTabs";
import { InvoiceTile } from "./invoices";
import CustomSerachBar from "../../components/CustomSerachBar";
import {
  getInvoiceList,
  getPaymentList,
} from "../../redux/paymentInvoice/action";
import { useDispatch, useSelector } from "react-redux";
import { Button, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import FullPageModal from "../../components/FullPageLoader";
import storePersist, { localConstant } from "../../services/localStorage";
import BottomNav from "../../components/BottomNav/BottomNav";
import EmptyDataLogo from "../../assets/png/emptyData.png";
import { RESET_INVOICE_LIST } from "../../redux/paymentInvoice/constants";

export const BillingPayments = () => {
  const myRef = useRef({});
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    invoiceList = [],
    paymentList,
    isLoading,
  } = useSelector((state) => state.paymentInvoiceReducer);
  const lgUp = useResponsive("up", "lg");
  const [tabValue, setTabValue] = useState(0);
  const [sortType, setSortType] = useState(true);
  const [billCharges, setBillCharges] = useState([]);
  const custId = storePersist.get(localConstant.ENTITY_CUSTOMER_ID);
  const handleChange = (newValue) => {
    setTabValue(newValue);
  };

  const handleCheckbox = (charges, isInclude) => {
    if (isInclude) {
      setBillCharges((prev) => {
        const exists = prev.some(
          (item) =>
            item.billNums === charges.billNums &&
            item.totalAmount === charges.totalAmount,
        );
        if (exists) {
          return prev;
        }
        return [...prev, { ...charges }];
      });
    } else {
      setBillCharges((prev) =>
        prev.filter((bill) => bill.billNums !== charges.billNums),
      );
    }
  };

  const handlePaymentSearch = (search) => {
    dispatch(getPaymentList(custId, { q: search }));
    dispatch(getInvoiceList(custId, { q: search }));
  };

  const onPressTile = (details) => {
    navigate("/billing_payments/details", {
      state: {
        billDetails: details,
      },
    });
  };

  const onClickSort = () => {
    setSortType((prev) => !prev);
  };

  useEffect(() => {
    setBillCharges([]);
  }, []);

  useEffect(() => {
    dispatch({ type: RESET_INVOICE_LIST });
    const sortOrder = sortType ? "desc" : "asc";
    dispatch(getInvoiceList(custId, { sort: sortOrder }));
    dispatch(getPaymentList(custId, { sort: sortOrder }));
  }, [sortType]);

  const getBillScreen = (tabNumber) => {
    switch (tabNumber) {
      case 0:
        return (
          <Grid>
            {invoiceList.map((item) => (
              <InvoiceTile
                isInvoice={true}
                invoiceNumber={item.charge_id}
                invoicePaymentNumber={item.payment_number}
                amount={item.net_amount}
                dueDate={item.due_date}
                paymentDate={item.charge_created_date}
                dueAmount={item.due_amount}
                isCheckboxClicked={false}
                handleCheckboxClick={handleCheckbox}
                onPressTile={onPressTile}
                billNumber={item?.bill_number}
                reservationId={item.primary_reference_id}
                chargeStatusCode={item.charge_status_code}
                locationId={item.location_id}
                chargeTypeCode={item.charge_type_code}
              />
            ))}
          </Grid>
        );
      case 1:
        return (
          <Box>
            {paymentList.map((item) => (
              <InvoiceTile
                reservationId={item.primary_reference_id}
                paymentType={item.payment_mode_code}
                paymentDate={item.payment_date}
                amount={item.payment_amount}
                isInvoice={false}
                onPressTile={onPressTile}
                paymentNumber={item.payment_number}
                transactionNumber={item.transaction_reference_number}
                paymentVersion={item.payment_version}
                paymentCode={item.payment_type_code}
                billNumber={item?.bill_number}
              />
            ))}
          </Box>
        );
    }
  };

  const onPressPayNow = () => {
    navigate("/billing_payments/payment", {
      state: {
        billing: {
          charges: billCharges,
        },
      },
    });
  };

  return (
    <div
      style={{
        width: lgUp ? `calc(100% - ${240}px)` : "100%",
        marginLeft: lgUp ? "240px" : 0,
        position: "relative",
      }}
    >
      <MenuAppBar myRef={myRef} title={t("pages.ownerDashboard.text05")} />
      <MenuBar myRef={myRef} activeTab={6} />
      <Box
        maxHeight={"90vh"}
        style={{ position: "relative" }}
        overflow={"scroll"}
      >
        <CustomTab
          tabs={["Invoices", "Payments"]}
          onChangeTabValue={handleChange}
          active={tabValue}
        />
        <Box ml={1} mr={1}>
          <Grid display={"flex"} justifyContent={"center"}>
            <Grid
              mt={1}
              width={{ xs: "100%", md: "70%" }}
              display={"flex"}
              justifyContent={"space-around"}
            >
              <Grid flex={9} marginLeft={2}>
                <CustomSerachBar
                  placeholder={
                    tabValue === 0
                      ? t("pages.payments.text36")
                      : t("pages.payments.text37")
                  }
                  onSearchClick={(serachText) => {
                    handlePaymentSearch(serachText);
                  }}
                />
              </Grid>
              {/* disabling for now will add this in nect release */}

              {/* <Grid flex={1} display={'flex'} justifyContent={'center'} alignItems={'center'} onClick={onClickSort} marginRight={1}>
                    <SortIcon />
              </Grid> */}
            </Grid>
          </Grid>
          <Grid pb={10}>
            {invoiceList.length > 0 || paymentList.length > 0 ? (
              getBillScreen(tabValue)
            ) : (
              <Grid
                height={"70vh"}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <img src={EmptyDataLogo} />
              </Grid>
            )}
          </Grid>
        </Box>
        {invoiceList.length > 0 && tabValue === 0 && (
          <Box
            display={"flex"}
            justifyContent={"center"}
            mt={3}
            mb={3}
            bottom={{ xs: 20, md: 0 }}
            width={"100%"}
            style={{ position: "sticky" }}
            backgroundColor="white"
            p={1}
            paddingTop={2}
            paddingBottom={3}
          >
            <Button
              variant="contained"
              disabled={billCharges.length === 0}
              mt={2}
              style={{
                alignSelf: "center",
                width: 106,
                height: 32,
                right: 10,
                marginLeft: 40,
                marginBottom: 3,
                display: "flex",
                borderRadius: 4,
                border: 1,
              }}
              onClick={() => {
                onPressPayNow();
              }}
            >
              <Typography variant="buttonText" color="common.buttonText">
                {t("pages.payments.text01")}
              </Typography>
            </Button>
          </Box>
        )}
      </Box>
      {isLoading && (
        <FullPageModal>
          <Grid>
            <Typography
              color={"white"}
              mt={2}
              fontSize={"17px"}
              fontWeight={"bold"}
            >
              {t("pages.payments.text02")}
            </Typography>
          </Grid>
        </FullPageModal>
      )}
      <BottomNav activeTab={7} />
    </div>
  );
};
